$(document).ready(function(){

  
  //collection desc read more
  // $('.read-more-collection').on('click', function(){
  //   $('#truncated , #truncated1').fadeOut(200, function(){ 
  //     $('#fullDescription').fadeIn(400);
  //     $('.read-less-collection').css('display','inline-block');
  //   })
  // });
  
  // $('.read-less-collection').on('click', function(){
  //   $('#fullDescription').fadeOut(200, function(){ 
  //     $('#truncated , #truncated1').fadeIn(400);
  //     $('.read-less-collection').css('display','none');
  //   })
  // });
   $('.read-more-collection').on('click', function(){
    $('#truncated , #truncated1 ').fadeOut(200, function(){ 
      $('#fullDescription').fadeIn(400);
      $('.read-less-collection').css('display','inline-block');
    })
  });
  
  $('.read-less-collection').on('click', function(){
    $('#fullDescription').fadeOut(200, function(){ 
      $('#truncated , #truncated1').fadeIn(400);
      $('.read-less-collection').css('display','none');
    })
  });

  
  $('.Coll-left-window .filter-drawer__group-heading-wrapper').click(function(){
        $(this).siblings('.filter-drawer__list').slideToggle();
          $(this).toggleClass('show');
  });

   // var divHeight = $('.header__outer-wrapper').height(); 
   // $('.Coll-left-window-inner').css('top', 20 + divHeight+'px');


  $(function () {
    // $(".accordion-content:not(:last-of-type)").css("display", "none");
    // $(".js-accordion-title:last-of-type").addClass("open");
   
    $(".js-accordion-title").click(function () {
      $(".open").not(this).removeClass("open").next().slideUp(300);
      $(this).toggleClass("open").next().slideToggle(300);
    });
  });
  
  $('.mob-filter-wrapper').hide();
  $('.coll-filter-mob button').click(function(){
      $('.mob-filter-wrapper').slideToggle();
    $(this).toggleClass('show');
  });
  if($(window).width() <= 959)
    {
      var divHeight = $('.header__outer-wrapper').height(); 
       $('.Coll-left-window').css('top', divHeight - 1 +'px');
    }



  //collection page sort filter for desktop
  $('.template-collection .collection__container .collection__main-area .Coll-right-window .Coll-right-sort select#SortBy').on('change', function(){
    var value = $(this).val();
    //console.log(value);
    if(value == 'sort'){
      $('.template-collection .collection__container .collection__main-area .collection__active-filters-container .active-filters__active-filter[data-name="sort_by"]').trigger('Click');
      $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .sort_panel .filter-drawer__footer .filter-drawer__button-clear').trigger('click');
      $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .sort_panel .filter-drawer__footer .filter-drawer__button-apply').trigger('click');
    }else{
    $('.template-collection .collection__container .collection__main-area .collection__active-filters-container .active-filters__active-filter[data-name="sort_by"]').trigger('Click');
    $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .sort_panel .filter-drawer__content .filter-drawer__list li input[name=sort_by][value="'+ value +'"]').attr('checked', 'checked');
    $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .sort_panel .filter-drawer__footer .filter-drawer__button-apply').trigger('click');
  //   setTimeout(function() {
  //   window.location.reload();
  // }, 500);
    }
  });

  $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .filter_panel .filter-drawer__list li input[type="checkbox"]:checked').parents('li').addClass('active');
  $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .filter_panel .filter-drawer__list li input').on('click', function(){
    $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .filter_panel .filter-drawer__footer .filter-drawer__button-apply').trigger('click');
  });

  $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .filter_panel .active-filters .active-filters__active-filter[data-name="sort_by"]').on('click', function(){
    var value = $(this).data('value');
    console.log(value);
    $('.collection__main-area .Coll-right-window .collection__active-filters-container .active-filters a[data-value="'+value+'"]').trigger('click');
  });


  //for mobile 
  $('.template-collection .collection__container .collection__main-area .Coll-left-window .coll-filter-mob .pro-sort li').each(function(){
    $(this).on('click', function(){
      var value = $(this).data('value');
      $('.template-collection .collection__container .collection__main-area .collection__active-filters-container .active-filters__active-filter[data-name="sort_by"]').trigger('Click');
      $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .sort_panel .filter-drawer__content .filter-drawer__list li input[name=sort_by][value="'+ value +'"]').attr('checked', 'checked');
      $('.template-collection .collection__container .collection__main-area .Coll-left-window .filter-drawer .sort_panel .filter-drawer__footer .filter-drawer__button-apply').trigger('click');
    });
  });


  //cart gift wrap

   function removeShippingInsurance(data){
    console.log('removed',data);
    $.ajax({
      url: "/cart/change.js",
      type: "POST",
      data: data,
      dataType: "json",
      success: function (response) {
        //getCart(true);
        //setCookie('package_removed','removed');
        window.location.reload();
        console.log("success");
      },
      error: function(error){
        console.log("error2");
      }

    });
  }
  
    $(document).on('change', '#gift-wrapping',function(){
    
    let isChecked = $(this).is(':checked');
    console.log(isChecked);
    
    var obj = {
      attributes: {
        'Shipping Insurance': isChecked ? "yes" : "no"
      }
    };

    console.log('obj',obj);
    $.ajax({
      url: "/cart/update.js",
      type: "POST",
      data: obj,
      dataType: "json",
      success: function (response) {
        console.log("success1");
        //getCart();
        //theme.updateCartSummaries(true);

      },
      error: function(error){
        console.log("error1");
      }
    });
    
    
    jQuery.getJSON('/cart.js', function(cart) {
    var items = cart.items;
      console.log(cart.item_count);
      if(cart.item_count == 1){
      	if(items[0].product_id == 7940827480316){
          var data = {
            quantity: 0,
            id:items[0].id
          }
          removeShippingInsurance(data);
		
        }else{
          if(isChecked == true){
         var totalPrice = cart.total_price;
          var get_cart_price = cart.total_price;
          var is_product_exist = false;
          var shippingVariant;
          var line;


          for(var i=0; i < items.length; i++){
            console.log('id',items[i].product_id);
            if(items[i].product_id  == 7940827480316){
              get_cart_price = (cart.total_price - items[i].price);
              shippingVariant = items[i].id;
              var line = i + 1;
              is_product_exist = true;
            } 

            if(is_product_exist == true) {
              break;
            }
          }
        var updates = {
          updates: {}
        };
        
          console.log('variant',shippingVariant);
        if(!shippingVariant){
          console.log('aavyu');
      
            updates['updates']['43972412571900'] = 1;
           
          console.log("==>",updates);
          $.ajax({
            url: "/cart/update.js",
            type: "POST",
            data: updates,
            dataType: "json",
            success: function (response) {
              //getCart(true);
              console.log('tytytytyty');
              //theme.updateCartSummaries(true);
              window.location.reload();
            },
            error: function(error){
            }
          });
        }
          }else{
            var variant_id;
              for(var i=0; i < items.length; i++){
                console.log('id',items[i].product_id);
                if(items[i].product_id  == 7940827480316){
                   variant_id = items[i].id;
                  var data = {
                    quantity: 0,
                    id:variant_id
                  }
                  removeShippingInsurance(data);
                } 

              }
          }
        }
      }else{
          if(isChecked == true){
          var totalPrice = cart.total_price;
          var get_cart_price = cart.total_price;
          var is_product_exist = false;
          var shippingVariant;
          var line;


          for(var i=0; i < items.length; i++){
            console.log('id',items[i].product_id);
            if(items[i].product_id  == 7940827480316){
              get_cart_price = (cart.total_price - items[i].price);
              shippingVariant = items[i].id;
              var line = i + 1;
              is_product_exist = true;
            } 

            if(is_product_exist == true) {
              break;
            }
          }
        
        var updates = {
          updates: {}
        };
        
          console.log('variant',shippingVariant);
        if(!shippingVariant){
            updates['updates']['43972412571900'] = 1;
          console.log("==>",updates);
          $.ajax({
            url: "/cart/update.js",
            type: "POST",
            data: updates,
            dataType: "json",
            success: function (response) {
              //getCart(true);
              console.log('tytytytyty');
              //theme.updateCartSummaries(true);
              window.location.reload();
            },
            error: function(error){
            }
          });
        }

        }else{
            var variant_id;
              for(var i=0; i < items.length; i++){
                console.log('id',items[i].product_id);
                if(items[i].product_id  == 7940827480316){
                   variant_id = items[i].id;
                  var data = {
                    quantity: 0,
                    id:variant_id
                  }
                  removeShippingInsurance(data);
                } 

              }
          }
      
      }
    });
    
    console.log('hjgj');
  });
});